// Platform detection helper — used to hide payment UI on iOS Capacitor
// (Apple App Store Guideline 3.1.1 compliance)

export function isIOSCapacitor() {
  try {
    // Capacitor exposes window.Capacitor in native apps
    if (typeof window === "undefined") return false;
    const cap = window.Capacitor;
    if (!cap) return false;
    const platform = cap.getPlatform ? cap.getPlatform() : cap.platform;
    return platform === "ios";
  } catch {
    return false;
  }
}

export function isAndroidCapacitor() {
  try {
    if (typeof window === "undefined") return false;
    const cap = window.Capacitor;
    if (!cap) return false;
    const platform = cap.getPlatform ? cap.getPlatform() : cap.platform;
    return platform === "android";
  } catch {
    return false;
  }
}

/** True inside any Capacitor native app (iOS or Android). Use this to opt into
 *  native-SDK OAuth flows (Google / Apple / Facebook) so sign-in stays INSIDE
 *  the installed app rather than kicking the user out to Safari / Chrome. */
export function isNativeCapacitor() {
  return isIOSCapacitor() || isAndroidCapacitor();
}

export function isWebOnly() {
  return !isNativeCapacitor();
}
